import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { TwitterShareButton } from 'react-share';
import _get from 'lodash/get';
import _noop from 'lodash/noop';

import {
    useBasePath,
    useMediaConfig,
    useDictionary,
    useLang,
} from '../hooks/config';
import { getMediaPath } from '../utils';

const TwitterButton = forwardRef(({
    mediaPlayback,
    onClick,
    children,
}, ref) => {
    
    const basePath = useBasePath();
    const dictionary = useDictionary();
    const config = useMediaConfig();
    const lang = useLang();
    const origin = __CLIENT__ ? window.location.origin : 'https://www.mlb.com';
    const mediaPath = getMediaPath(mediaPlayback);
    const link = `${origin}${basePath}/${mediaPath}`;
    const blurb = _get(mediaPlayback, 'blurb');

    const Content = React.cloneElement(children, {
        dictionary: dictionary,
    });

    return (
        <TwitterShareButton
            ref={ref}
            title={blurb}
            url={link}
            via={_get(config, `shareConfig.twitterHandle.${lang}`, 'MLB')}
            aria-label={_get(dictionary, 'share_with_twitter_text', 'Share on Twitter')}
            hashtags={_get(config, 'shareConfig.twitterHashtags', '')}
            onClick={onClick}
        >
            {Content}
        </TwitterShareButton>
    );

});

TwitterButton.propTypes = {
    mediaPlayback: PropTypes.object.isRequired,
    onClick: PropTypes.func,
    children: PropTypes.node,
};

TwitterButton.defaultProps = {
    onClick: _noop,
    children: undefined,
};

export default TwitterButton;
